import SectionHeader from "../SectionHeader";
import { CONTACT, FREE_EDIT_LABEL } from "../../data/site";

export const HowWeWork = () => (
  <section data-testid="how-we-work-section" className="bg-[#111] section-pad">
    <div className="container-x -mb-14 md:-mb-20">
      <SectionHeader
        align="split"
        eyebrow="How we work"
        eyebrowTestId="how-we-work-eyebrow"
        title="A full editing team, without hiring one."
        support="Send footage, get cuts back. No timelines to manage, no editor to onboard, no month where nothing ships. You explain it once: the same person holds your brief in month one and month nine, and the team behind them covers whatever the video needs."
        action={
          <a
            data-testid="how-we-work-free-edit-btn"
            href={CONTACT.freeEditLink}
            target="_blank"
            rel="noreferrer"
            className="btn-primary"
          >
            {FREE_EDIT_LABEL}
          </a>
        }
      />
    </div>
  </section>
);

export default HowWeWork;
